import { useEffect } from 'react';
// @mui
import { Button, Container, Stack } from '@mui/material';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// routes
import { paths } from 'src/routes/paths';
import { useNavigate } from 'react-router-dom';
// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getReports, getReport, deleteReportTemplate, getTemplate } from 'src/redux/slices/report';
// components
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useSettingsContext } from 'src/components/settings';
// dto
import { ReportTemplateDto } from 'src/api';
// hooks
import { useParams } from '../../../routes/hook';
// locales
import { useLocales } from '../../../locales';
// components
import ReportEditBuilder from './report-edit-builder';
import ReportEditDialog from './report-edit-dialog';

export default function ReportEditView() {
  const params = useParams();

  const { id = '' } = params;

  const navigate = useNavigate();

  const { t } = useLocales();

  const settings = useSettingsContext();

  const dispatch = useDispatch();

  const dialogState = useBoolean(false);

  const template: ReportTemplateDto = useSelector((state) => state.report.report);

  if (template.editable === false) {
    navigate(paths.report.root);
  }

  useEffect(() => {
    dispatch(getReport({ templateId: id }));
    dispatch(getTemplate());
  }, [dispatch, id]);

  const handleDeleteReport = () => {
    dispatch(deleteReportTemplate({ templateId: id })).then(() => {
      dispatch(getReports());
      navigate(paths.report.root);
    });
  };

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <CustomBreadcrumbs
        heading={template.name}
        links={[
          { name: t('Dashboard'), href: paths.dashboard.root },
          {
            name: t('Reports'),
            href: paths.report.root,
          },
          { name: t('Edit') },
        ]}
        action={
          <Stack direction="row" spacing={1}>
            <Button onClick={handleDeleteReport} variant="outlined">
              {t('Delete report')}
            </Button>
            <Button onClick={dialogState.onTrue} variant="contained" color="primary">
              {t('Save report')}
            </Button>
          </Stack>
        }
        sx={{ mb: { xs: 3, md: 5 } }}
      />

      <ReportEditBuilder />
      <ReportEditDialog openState={dialogState} />
    </Container>
  );
}
